
<div class="container">
    <div class="wrapper">
  
      <div style="max-width: 600px; margin: 0 0px 20px 0">
        <div class="title-section title">
          <ion-icon class="item-icono" name="alert-circle"></ion-icon>
          {{ ops.titleRetry }}
        </div>
  
        <div class="mb-50">
          <ion-text class="sub-title">
            <div [innerHTML]="ops.infoRetry"></div>
          </ion-text>
        </div>
        <div class="div-text-g-error" *ngIf="ops.subtitleRetry">
          <p class="fw-700" style="margin-bottom: 3px;">Para más información</p>
          <ion-text [innerHTML]="ops.subtitleRetry" class="fw-400">
          </ion-text>
        </div>
        
        <button class="button primary-button" *ngIf="enableButtonRetry" (click)="retryEvent.emit()" >
            {{ops.buttonTextPrimary}}
            <ion-icon name="refresh-outline" *ngIf="!retryAttempt" style="font-size: 20px; margin-left: 5px;"></ion-icon>
            <ion-spinner name="crescent" slot="end" *ngIf="retryAttempt" color="light"></ion-spinner>
        </button>
          
          <button class="button" [ngClass]="enableButtonRetry ? 'b-btn s-button secondary-button' : 'b-btn p-button primary-button'"  (click)="goToEvent.emit()">
            {{ops.buttonTextSecondary}}
        </button>

      </div>
    </div>
  </div>